import { IntlShape } from 'react-intl';
import { ModuleHierachy } from 'src/app/common/module/types';
import { isPermitted } from 'src/app/common/utils';
import {
  OPM_PD_TITLE,
  POLICY_TRANSFER_REQUEST_TITLE,
  OPM_PD_BASE_PATH,
  POLICY_TRANSFER_REQUEST_PATH,
  OPM_PD_POLICY_TRANSFER_REQUEST_NAMESPACE,
  AdminOpmPdPermissionType,
  OPM_PD_LM_APPROVAL_NAMESPACE,
  REQUEST_APPROVAL_TO_LINE_MANAGER_PATH,
  REQUEST_APPROVAL_TO_LINE_MANAGER_TITLE,
  REPORT_FOR_ADMIN_TITLE,
  REPORT_FOR_ADMIN_PATH,
  OPM_PD_ADMIN_REPORT_NAMESPACE,
} from './constants';
import PolicyRequestTransfer from './pages/PolicyRequestTransfer/PolicyRequestTransferRoutes';
import RequestApprovalToLineManagerRoutes from './pages/RequestApprovalToLineManager/RequestApprovalToLineManagerRoutes';
import ReportForAdminRoutes from './pages/ReportForAdmin/ReportForAdminRoutes';

export const opmPdModuleConfig = (permissions: string[], intl: IntlShape): ModuleHierachy => {
  const Translation = (id: string) => intl.formatMessage({ id });
  return {
    title: Translation(OPM_PD_TITLE),
    path: OPM_PD_BASE_PATH,
    icon: '/media/svg/icons/Communication/Chat1.svg',
    enableRead: isPermitted(
      [
        AdminOpmPdPermissionType.OPM_PD_POLICY_TRANSFER_REQUEST_READ,
        AdminOpmPdPermissionType.OPM_PD_LM_APPROVAL_READ,
        AdminOpmPdPermissionType.OPM_PD_ADMIN_REPORT_READ,
      ],
      permissions,
    ),
    disableRoleControl: true,
    child: [
      {
        title: Translation(POLICY_TRANSFER_REQUEST_TITLE),
        path: `${OPM_PD_BASE_PATH}${POLICY_TRANSFER_REQUEST_PATH}`,
        namespace: OPM_PD_POLICY_TRANSFER_REQUEST_NAMESPACE,
        component: PolicyRequestTransfer,
        enableRead: isPermitted(
          [
            AdminOpmPdPermissionType.OPM_PD_POLICY_TRANSFER_REQUEST_CREATE,
            AdminOpmPdPermissionType.OPM_PD_POLICY_TRANSFER_REQUEST_READ,
            AdminOpmPdPermissionType.OPM_PD_POLICY_TRANSFER_REQUEST_UPDATE,
          ],
          permissions,
        ),
        enableCreate: isPermitted([AdminOpmPdPermissionType.OPM_PD_POLICY_TRANSFER_REQUEST_CREATE], permissions),
        enableUpdate: isPermitted([AdminOpmPdPermissionType.OPM_PD_POLICY_TRANSFER_REQUEST_UPDATE], permissions),
      },
      {
        title: Translation(REQUEST_APPROVAL_TO_LINE_MANAGER_TITLE),
        path: `${OPM_PD_BASE_PATH}${REQUEST_APPROVAL_TO_LINE_MANAGER_PATH}`,
        namespace: OPM_PD_LM_APPROVAL_NAMESPACE,
        component: RequestApprovalToLineManagerRoutes,
        enableRead: isPermitted(
          [
            AdminOpmPdPermissionType.OPM_PD_LM_APPROVAL_READ,
            AdminOpmPdPermissionType.OPM_PD_LM_APPROVAL_READ,
            AdminOpmPdPermissionType.OPM_PD_LM_APPROVAL_UPDATE,
          ],
          permissions,
        ),
        enableCreate: isPermitted([AdminOpmPdPermissionType.OPM_PD_LM_APPROVAL_CREATE], permissions),
        enableUpdate: isPermitted([AdminOpmPdPermissionType.OPM_PD_LM_APPROVAL_UPDATE], permissions),
      },
      {
        title: Translation(REPORT_FOR_ADMIN_TITLE),
        path: `${OPM_PD_BASE_PATH}${REPORT_FOR_ADMIN_PATH}`,
        namespace: OPM_PD_ADMIN_REPORT_NAMESPACE,
        component: ReportForAdminRoutes,
        enableRead: isPermitted(
          [
            AdminOpmPdPermissionType.OPM_PD_ADMIN_REPORT_READ,
            AdminOpmPdPermissionType.OPM_PD_ADMIN_REPORT_READ,
            AdminOpmPdPermissionType.OPM_PD_ADMIN_REPORT_UPDATE,
          ],
          permissions,
        ),
        enableCreate: isPermitted([AdminOpmPdPermissionType.OPM_PD_ADMIN_REPORT_CREATE], permissions),
        enableUpdate: isPermitted([AdminOpmPdPermissionType.OPM_PD_ADMIN_REPORT_UPDATE], permissions),
      },
    ],
  };
};
